module.exports = __webpack_public_path__ + "img/opened_capsules.619db0de.png";